import { Injectable } from '@angular/core';

@Injectable()
export class AnchorService {
  public iconClasses?: string;
}
